import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA3jEi9utkFO8uFEOJgIkC4ffW7wN5fh5s",
  authDomain: "lead-now-a56fa.firebaseapp.com",
  projectId: "lead-now-a56fa",
  storageBucket: "lead-now-a56fa.firebasestorage.app",
  messagingSenderId: "1064549001833",
  appId: "1:1064549001833:web:b1f99808e2daa5944bd0f8",
  measurementId: "G-K06Z174BXC"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export default app;